
import { defineComponent } from 'vue';
import Loading from '@/components/atoms/Loading.vue';
import { getClientConfig, setClientFavicon } from '@/service/clientService';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'App',
  components: {
    Loading
  },
  async mounted () {
    this.startLoading();
    await getClientConfig();
    setClientFavicon();
    this.endLoading();
  },
  methods: {
    ...mapActions(['startLoading', 'endLoading'])
  },
  computed: {
    ...mapGetters([
      'global',
      'isLoading',
      'configIsSet'
    ])
  }
});
